module.exports = __webpack_public_path__ + "img/PL.37aecb21.svg";